"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseConnextLog = exports.axiosGetRequest = exports.validateUri = exports.calculateRelayerFee = exports.getDecimalsForAsset = exports.getHardcodedGasLimits = exports.getGelatoEstimatedFee = exports.getConversionRate = exports.domainToChainId = exports.getChainData = exports.relayerBufferPercentage = void 0;
const nxtp_txservice_1 = require("@connext/nxtp-txservice");
const nxtp_utils_1 = require("@connext/nxtp-utils");
const index_1 = require("../errors/index");
exports.relayerBufferPercentage = 20; // 20% bump on total estimated relayer fee
exports.getChainData = nxtp_utils_1.getChainData;
exports.domainToChainId = nxtp_utils_1.domainToChainId;
exports.getConversionRate = nxtp_utils_1.getConversionRate;
exports.getGelatoEstimatedFee = nxtp_utils_1.getGelatoEstimatedFee;
exports.getHardcodedGasLimits = nxtp_utils_1.getHardcodedGasLimits;
exports.getDecimalsForAsset = nxtp_utils_1.getDecimalsForAsset;
exports.calculateRelayerFee = nxtp_utils_1.calculateRelayerFee;
const validateUri = (uri) => {
    const validateInput = nxtp_utils_1.ajv.compile(nxtp_utils_1.TUrl);
    const validInput = validateInput(uri);
    if (!validInput) {
        const msg = validateInput.errors?.map((err) => `${err.instancePath} - ${err.message}`).join(",");
        throw new index_1.UriInvalid({
            paramsError: msg,
            uri,
        });
    }
};
exports.validateUri = validateUri;
const axiosGetRequest = async (uri) => {
    try {
        const response = await (0, nxtp_utils_1.axiosGet)(uri);
        return response.data;
    }
    catch (err) {
        throw new index_1.ApiRequestFailed({ error: (0, nxtp_utils_1.jsonifyError)(err) });
    }
};
exports.axiosGetRequest = axiosGetRequest;
const parseConnextLog = (log) => {
    const contracts = (0, nxtp_txservice_1.getContractInterfaces)();
    try {
        return contracts.connext.parseLog(log);
    }
    catch (error) {
        throw new index_1.ParseConnextLogFailed({ log });
    }
};
exports.parseConnextLog = parseConnextLog;
//# sourceMappingURL=shared.js.map